export const formatUserName = (email: string): string => {
  const fullName = email.split('@')[0]
  const firstName = fullName.split('.')[0]
  const lastName = fullName.split('.')[1]

  return firstName + ' ' + lastName
}
